export class MentionListComponent {
  constructor(props) {
    this.props = props;
    this.selectedIndex = 0;
  }

  updateProps(props) {
    this.props = props;
    this.selectedIndex = 0;
    this.render();
  }

  onKeyDown({ event }) {
    console.log('Key down event:', event.key);
    if (event.key === 'ArrowUp') {
      if (this.props.items && this.props.items.length) {
        this.upHandler();
        return true;
      }
    }
    if (event.key === 'ArrowDown') {
      if (this.props.items && this.props.items.length) {
        this.downHandler();
        return true;
      }
    }
    if (event.key === 'Enter') {
      this.enterHandler();
      return true;
    }
    if (event.key === 'Tab') {
      this.enterHandler();
      return true;
    }
    if (event.key === 'Escape') {
      this.props.exit?.();
      return true;
    }
    return false;
  }

  upHandler() {
    this.selectedIndex = (this.selectedIndex + this.props.items.length - 1) % this.props.items.length;
    this.render();
  }

  downHandler() {
    this.selectedIndex = (this.selectedIndex + 1) % this.props.items.length;
    this.render();
  }

  enterHandler() {
    this.selectItem(this.selectedIndex);
  }

  selectItem(index) {
    const item = this.props.items[index];
    if (item) {
      this.props.command({
        id: item.id,
        label: item.name || item.email || 'Unknown User',
      });
    }
  }

  render(element) {
    if (element) this.element = element;
    if (!this.element) return;

    this.element.innerHTML = '';
    
    if (!this.props.items || this.props.items.length === 0) {
      this.props.exit?.();
      return;
    }

    this.props.items.forEach((item, index) => {
      const suggestion = document.createElement('button');
      suggestion.className = `mention-suggestion ${index === this.selectedIndex ? 'is-active' : ''}`;
      suggestion.onclick = () => this.selectItem(index);
      
      const name = document.createElement('div');
      name.className = 'mention-suggestion__name';
      name.textContent = item.name || item.email || 'Unknown User';
      
      const email = document.createElement('div');
      email.className = 'mention-suggestion__email';
      email.textContent = item.email;
      
      suggestion.appendChild(name);
      suggestion.appendChild(email);
      this.element.appendChild(suggestion);
    });

    this.positionPopup();
  }

  handleDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.hideSuggestions();
    }
  }


  positionPopup() {
    if (!this.element || !this.props.clientRect) return;
    
    const rect = this.props.clientRect();
    if (rect) {
      this.element.style.position = 'fixed';
      this.element.style.left = `${Math.round(rect.left)}px`;
      this.element.style.top = `${Math.round(rect.bottom + 8)}px`;
      this.element.style.zIndex = '9999';
      // Avoid class-based right: 0 stretching the popup across the viewport
      this.element.style.right = 'auto';
      // Give the popup a sensible minimum width so names are visible
      const baseWidth = Math.max(240, Math.round(rect.width || 0));
      this.element.style.minWidth = `${baseWidth}px`;
      // Optional cap to prevent overly wide menus on large selections
      this.element.style.maxWidth = '480px';
    }
  }
}
